import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: 'primary.main',
        color: 'white',
        textAlign: 'center',
        padding: '8px 0',
        position: 'fixed',
        bottom: 0,
        left: 0,
        height: '7vh',
      }}
    >
      <Typography variant="body1">© 2025 LTIMindtree. All rights reserved.</Typography>
    </Box>
  );
};

export default Footer;